export const getNavConfig = (router, signOut) => {
  return [
    [
      {
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12.0002 21.0002C14.122 21.0002 16.1569 20.1573 17.6572 18.657C18.4012 17.9149 18.9912 17.0331 19.3932 16.0623C19.7953 15.0915 20.0016 14.0508 20.0002 13C20.0015 11.9491 19.795 10.9084 19.3928 9.93756C18.9905 8.96674 18.4004 8.08499 17.6562 7.343C16.0902 5.777 14.0002 5 11.9862 3C9.50021 5 9.00021 8 9.00021 10C7.00021 9 6.34321 7.343 6.34321 7.343C4.84288 8.84333 4 10.8782 4 13C4 15.1218 4.84288 17.1567 6.34321 18.657C7.84354 20.1573 9.87842 21.0002 12.0002 21.0002Z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.1277 16.8702C10.6563 16.7268 10.2274 16.4695 9.879 16.121C9.293 15.536 9 14.768 9 14H11L12.015 11C12.5078 11.0024 12.9923 11.1261 13.4259 11.3602C13.8595 11.5943 14.2288 11.9316 14.5011 12.3423C14.7733 12.753 14.9402 13.2245 14.987 13.715C15.0338 14.2056 14.9591 14.7001 14.7694 15.1548C14.5797 15.6096 14.2809 16.0107 13.8994 16.3226C13.5179 16.6345 13.0655 16.8476 12.5821 16.9431C12.0986 17.0386 11.5991 17.0135 11.1277 16.8702Z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        name: '任務',
        path: '/profile/mission',
        handler: () => {
          router.push('/profile/mission');
        },
      },
      {
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M9 12H15M9 16H15M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H12.586C12.8512 3.00006 13.1055 3.10545 13.293 3.293L18.707 8.707C18.8946 8.89449 18.9999 9.1488 19 9.414V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        name: '積分記錄',
        path: '/profile/score',
        handler: () => {
          router.push('/profile/score');
        },
      },
      {
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 8V21M12 8V6C12 5.60444 12.1173 5.21776 12.3371 4.88886C12.5568 4.55996 12.8692 4.30362 13.2346 4.15224C13.6001 4.00087 14.0022 3.96126 14.3902 4.03843C14.7781 4.1156 15.1345 4.30608 15.4142 4.58579C15.6939 4.86549 15.8844 5.22186 15.9616 5.60982C16.0387 5.99778 15.9991 6.39992 15.8478 6.76537C15.6964 7.13082 15.44 7.44318 15.1111 7.66294C14.7822 7.8827 14.3956 8 14 8H12ZM12 8V5.5C12 5.00555 11.8534 4.5222 11.5787 4.11108C11.304 3.69995 10.9135 3.37952 10.4567 3.1903C9.99989 3.00108 9.49723 2.95157 9.01227 3.04804C8.52732 3.1445 8.08186 3.3826 7.73223 3.73223C7.3826 4.08187 7.1445 4.52732 7.04804 5.01228C6.95157 5.49723 7.00108 5.99989 7.1903 6.45671C7.37952 6.91352 7.69995 7.30397 8.11107 7.57867C8.5222 7.85338 9.00555 8 9.5 8H12ZM5 12H19M5 12C4.46957 12 3.96086 11.7893 3.58579 11.4142C3.21071 11.0391 3 10.5304 3 10C3 9.46957 3.21071 8.96086 3.58579 8.58579C3.96086 8.21072 4.46957 8 5 8H19C19.5304 8 20.0391 8.21072 20.4142 8.58579C20.7893 8.96086 21 9.46957 21 10C21 10.5304 20.7893 11.0391 20.4142 11.4142C20.0391 11.7893 19.5304 12 19 12M5 12V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V12"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        name: '兌換記錄',
        path: '/profile/redeem',
        handler: () => {
          router.push('/profile/redeem');
        },
      },
    ],
    [
      {
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M15 5V7M15 11V13M15 17V19M5 5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V10C3.53043 10 4.03914 10.2107 4.41421 10.5858C4.78929 10.9609 5 11.4696 5 12C5 12.5304 4.78929 13.0391 4.41421 13.4142C4.03914 13.7893 3.53043 14 3 14V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V14C20.4696 14 19.9609 13.7893 19.5858 13.4142C19.2107 13.0391 19 12.5304 19 12C19 11.4696 19.2107 10.9609 19.5858 10.5858C19.9609 10.2107 20.4696 10 21 10V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5Z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        name: '優惠券',
        path: '/profile/voucher',
        quantity: 0,
        handler: () => {
          router.push('/profile/voucher');
        },
      },
      {
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 6.253V19.253M12 6.253C10.832 5.477 9.246 5 7.5 5C5.754 5 4.168 5.477 3 6.253V19.253C4.168 18.477 5.754 18 7.5 18C9.246 18 10.832 18.477 12 19.253M12 6.253C13.168 5.477 14.754 5 16.5 5C18.247 5 19.832 5.477 21 6.253V19.253C19.832 18.477 18.247 18 16.5 18C14.754 18 13.168 18.477 12 19.253"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        name: '會員專屬內容',
        path: '/profile/memberscontent',
        handler: () => {
          router.push('/profile/memberscontent');
        },
      },
      {
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V21L12 17.5L19 21V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579Z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        name: '我的收藏',
        path: '/profile/save',
        handler: () => {
          router.push('/profile/save');
        },
      },
    ],
    [
      {
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M17 16L21 12M21 12L17 8M21 12H7M13 16V17C13 17.7956 12.6839 18.5587 12.1213 19.1213C11.5587 19.6839 10.7956 20 10 20H6C5.20435 20 4.44129 19.6839 3.87868 19.1213C3.31607 18.5587 3 17.7956 3 17V7C3 6.20435 3.31607 5.44129 3.87868 4.87868C4.44129 4.31607 5.20435 4 6 4H10C10.7956 4 11.5587 4.31607 12.1213 4.87868C12.6839 5.44129 13 6.20435 13 7V8"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        name: '登出',
        handler: () => {
          signOut();
        },
      },
    ],
  ];
};
